import React from "react"

const ProviderDetailsContext = React.createContext({})

const { Provider, Consumer } = ProviderDetailsContext

export { Provider, Consumer, ProviderDetailsContext }
